module.exports = __webpack_public_path__ + "static/img/sanjichangjiangwenyi.f20ef18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/sanjichangjiangwenyi.jpg
// module id = CvDK
// module chunks = 46